// test369
(369 && 0);
